export default class PdfBoolean extends Boolean {
  constructor(value: boolean) {
    super(value);
  }

  toString(): string {
    return `${this.valueOf()}`;
  }
}
